export const SET_PLATFORM = 'jora-employer/platform/SET_PLATFORM';
export const TRACK_BROWSER_DETAILS =
  'jora-employer/platform/TRACK_BROWSER_DETAILS';
export const TRACK_DEVICE_DETAILS =
  'jora-employer/platform/TRACK_DEVICE_DETAILS';
export const TRACK_ENABLE_PUSH_NOTIFICATIONS =
  'jora-employer/platform/TRACK_ENABLE_PUSH_NOTIFICATIONS';
export const TRACK_CANCEL_PUSH_NOTIFICATIONS =
  'jora-employer/platform/TRACK_CANCEL_PUSH_NOTIFICATIONS';
